import { render, staticRenderFns } from "./accordeon.vue?vue&type=template&id=542b0718&scoped=true"
import script from "./accordeon.vue?vue&type=script&lang=js"
export * from "./accordeon.vue?vue&type=script&lang=js"
import style0 from "./accordeon.vue?vue&type=style&index=0&id=542b0718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b0718",
  null
  
)

export default component.exports